<template>
  <v-dialog persistent v-bind="[$attrs, $props]" width="567">
    <v-form ref="form" class="px-12 pt-9 pb-7 white">
      <v-row class="pb-12">
        <v-col cols="12">
          <p class="primary--text font-weight-bold mb-2">
            {{ title }}
          </p>
        </v-col>
        <v-col cols="12">
          <BaseFormTextArea
            id-element="disclaimerSubModalityInsurance"
            placeholder="Inserir texto"
            v-model="form.comentario"
            label-text="Mensagem"
            :rules="isRequired"
          />
        </v-col>
        <v-col cols="12" class="pb-1">
          <p class="primary--text mb-2 body-2 font-weight-bold">
            Anexar documentos (se necessários)
          </p>
          <DropFile
            @selected-files="addFilesCriticism"
            :multiple="true"
            class="mb-5"
          />
          <DocumentDataTable
            v-if="form.documentos.length > 0"
            :documents="form.documentos"
            @preview-file="onPreviewFile"
            @remove-file="onRemoveFileCriticism"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-spacer />
        <v-col cols="6" sm="3" class="pr-5">
          <BaseButton
            v-html="'CANCELAR'"
            color="secondary"
            outlined
            width="100%"
            @click="closeModal"
          />
        </v-col>
        <v-col cols="6" sm="3">
          <BaseButton
            v-html="'ENVIAR'"
            class="secondary"
            width="100%"
            @click="submit"
          />
        </v-col>
      </v-row>
    </v-form>
  </v-dialog>
</template>
<script>
import { requiredInput } from "@/utils/rules.js";
import DocumentDataTable from "@/components/DocumentDataTable";
import DropFile from "@/components/DropFile";
import DocumentsMixin from "@/mixins/DocumentsMixin";
export default {
  data: () => ({
    form: {
      comentario: null,
      documentos: []
    },
    requiredInput
  }),
  components: {
    DocumentDataTable,
    DropFile
  },
  mixins: [DocumentsMixin],
  computed: {
    isRequired() {
      return this.required ? [requiredInput] : [];
    }
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },
    submit() {
      if (this.$refs.form.validate()) this.$emit("submit", this.form);
    },
    addFilesCriticism(files) {
      this.form.documentos = this.addFiles(this.form.documentos, files);
    },
    onRemoveFileCriticism(item) {
      this.form.documentos = this.onRemoveFile(this.form.documentos, item);
    }
  },
  props: {
    title: {
      type: String,
      default: "Responder Mensagem"
    },
    required: {
      type: Boolean,
      default: true
    }
  }
};
</script>
<style lang="sass"></style>
